import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Form, Checkbox } from 'semantic-ui-react'

class RubricaOggettiOrfani extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                mostraOrfani: props.mostraOrfani,
            }
        };
        this.onTipoChange = this.onTipoChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            fields: {
                mostraOrfani: nextProps.mostraOrfani,
            }
        })
    }

    onTipoChange(a1, {name, checked}){
        let fields = this.state.fields;
        fields[name] = checked;
        this.setState({fields})
        this.props.onChange(fields.mostraOrfani);
    }

    render() {
        return (
        <div className="ui stackable form">
            <Form.Group widths="1">
                <Form.Field inline >
                    <Checkbox label={this.props.label} name="mostraOrfani" toggle checked={this.state.fields.mostraOrfani} onChange={this.onTipoChange} />
                </Form.Field>
            </Form.Group>
        </div>)
    }
}

RubricaOggettiOrfani.PropTypes = {
    mostraOrfani: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

RubricaOggettiOrfani.defaultProps = {
    mostraOrfani: false,
    label: 'Mostra orfani',
};
export default RubricaOggettiOrfani;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaOggettiOrfani.js
 **/